import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ type, onCreateJob }) => {
  const getEmptyStateContent = () => {
    switch (type) {
      case 'active':
        return {
          icon: 'Briefcase',
          title: 'Geen actieve opdrachten',
          description: 'U heeft momenteel geen actieve opdrachten. Plaats een nieuwe opdracht om te beginnen.',
          showButton: true
        };
      case 'open':
        return {
          icon: 'Search',
          title: 'Geen openstaande opdrachten',
          description: 'Alle opdrachten zijn toegewezen of voltooid.',
          showButton: true
        };
      case 'completed':
        return {
          icon: 'CheckCircle',
          title: 'Geen voltooide opdrachten',
          description: 'Voltooide opdrachten worden hier weergegeven.',
          showButton: false
        };
      case 'filtered':
        return {
          icon: 'Filter',
          title: 'Geen resultaten gevonden',
          description: 'Probeer uw filters aan te passen om meer resultaten te zien.',
          showButton: false
        };
      default:
        return {
          icon: 'Briefcase',
          title: 'Geen opdrachten',
          description: 'Begin met het plaatsen van uw eerste opdracht.',
          showButton: true
        };
    }
  };

  const content = getEmptyStateContent();

  return (
    <div className="flex flex-col items-center justify-center py-12 md:py-16 lg:py-20 px-4">
      <div className="w-16 h-16 md:w-20 md:h-20 bg-muted rounded-full flex items-center justify-center mb-4">
        <Icon name={content?.icon} size={32} className="text-muted-foreground" />
      </div>
      <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground mb-2 text-center">
        {content?.title}
      </h3>
      <p className="text-sm md:text-base text-muted-foreground text-center max-w-md mb-6">
        {content?.description}
      </p>
      {content?.showButton && (
        <Button
          variant="default"
          onClick={onCreateJob}
          iconName="Plus"
          iconPosition="left"
        >
          Nieuwe Opdracht Plaatsen
        </Button>
      )}
    </div>
  );
};

export default EmptyState;